<div class="tab-section" *ngIf="removedOaData.length > 0">
    
    <div >
    <p-table [value]="removedOaData" [scrollable]="true" id="StyleTable" scrollHeight="400px">
        <ng-template pTemplate="header">
            <tr>
                <th>My TLR's</th>
                <th>TLR Status</th>
                <th></th>
                <th>Permanent Repair Date</th>
                <th></th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td [ngClass]="row.cssClass">{{row.tag_number}}</td>
                <td [ngClass]="row.cssClass">{{row.status}}</td>
                <td><a (click)="details(row)" class="link-underline">Details</a></td>
                <td >{{row.PermanentRepairDate | date:'dd-MM-yyyy'}}</td>
                <td><a (click)="editOa(row)" class="link-underline">Edit OA</a></td>
            </tr>
        </ng-template>
    </p-table>
</div>

</div>
<div *ngIf="removedOaData.length == 0">
    <p class="messageTitle">You do not own any TLR OA Records (Removed)</p>
</div>